module.exports = "/images/template-editor-icon.svg?66495fcf1559720748012ab5a3b5be2f";